import { Toaster as SonnerToaster } from "sonner";
import { useSettingStore } from "@/store/setting-store";


const BASE = "!rounded-xl !border-none !text-sm !font-medium !shadow-lg !p-3";

export default function Toaster() {
  const isFullscreen = useSettingStore((s) => s.isFullscreen);

  return (
    <SonnerToaster
      position="top-center"
      dir="rtl"
      closeButton
      expand={false}
      visibleToasts={3}
      mobileOffset={{
        top: isFullscreen ? 80 : 16,
      }}
      toastOptions={{
        style: { fontFamily: "inherit" },
        classNames: {
          toast: BASE,
          title: "!text-sm !leading-6",
          description: "!text-xs !opacity-80",
          closeButton: "!left-0 !right-auto !top-4 !bg-background !border-none !text-default-600 hover:!bg-default-100",
          default: "!bg-background !text-default-900",
          success: "!bg-success-50 !text-success",
          info: "!bg-info-50 !text-info",
          warning: "!bg-warning-50 !text-warning",
          error: "!bg-danger-50 !text-danger",
        },
      }}
    />
  );
}
